export default "__VITE_ASSET__74689661__"